import {
  SidePanelDS,
  InputDS,
  Spacer,
  TextCapitalized,
  CardVehicleAndDriver,
} from "@qivia/ui";
import { styled } from "styled-components";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { VehicleGeolocated } from "./index";
import { colors } from "@qivia/ui/src/styles/figmaColors";

type GeolocationSidePanelProps = {
  vehiclesToDisplay: VehicleGeolocated[];
  setHoveredVehicleId: (vehicleId: string | null) => void;
  handleSelectVehicle: (vehicle: VehicleGeolocated) => void;
};

export const GeolocationSidePanel = (props: GeolocationSidePanelProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const { vehiclesToDisplay, setHoveredVehicleId, handleSelectVehicle } = props;

  const handleVehicleHover = (vehicleId: string | null) => {
    setHoveredVehicleId(vehicleId);
  };

  const vehiclesToShowInPanel = vehiclesToDisplay.filter(
    (v) =>
      v.registrationNumber?.toLowerCase().includes(search.toLowerCase()) ||
      v.reference?.toLowerCase().includes(search.toLowerCase()) ||
      v.driverName?.toLowerCase().includes(search.toLowerCase()) ||
      v.driverPhone?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <StyledSidePanel>
      <SidePanelDS.SidePanelExpandable
        title={t("geolocation.sidePanel.title")}
        header={
          <SidePanelDS.Section>
            <InputDS
              name="vehicle"
              placeholder={t("geolocation.sidePanel.searchPlaceholder")}
              type="SEARCH"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
          </SidePanelDS.Section>
        }
      >
        <SidePanelDS.Section>
          <SidePanelDS.ActionBlock withoutBorder>
            {vehiclesToDisplay.length === 0 ? (
              <StyledNoVehicles>
                <TextCapitalized>
                  {t("geolocation.sidePanel.emptyContent.title")}
                </TextCapitalized>
              </StyledNoVehicles>
            ) : (
              vehiclesToShowInPanel.map((vehicle) => {
                return (
                  <div key={vehicle.uuid}>
                    <Spacer y={0.1} />
                    <CardVehicleAndDriver
                      vehicle={vehicle}
                      badgeText={vehicle.reference}
                      driver={
                        vehicle.driverName
                          ? {
                              firstName: vehicle.driverName.split(" ")[0],
                              lastName: vehicle.driverName.split(" ")[1],
                              phone: vehicle.driverPhone ?? "",
                            }
                          : undefined
                      }
                      distance={vehicle.distance || 0}
                      onClick={() => handleSelectVehicle(vehicle)}
                      onMouseEnter={() => handleVehicleHover(vehicle.uuid)}
                      onMouseLeave={() => handleVehicleHover(null)}
                    />
                    <Spacer y={1} />
                  </div>
                );
              })
            )}
          </SidePanelDS.ActionBlock>
        </SidePanelDS.Section>
      </SidePanelDS.SidePanelExpandable>
    </StyledSidePanel>
  );
};

const StyledSidePanel = styled.div`
  z-index: 1001;
`;

const StyledNoVehicles = styled.div`
  color: ${colors["colors/text/lightGrey"]};
  text-align: center;
`;
